import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const MERCADO_PAGO_URL = '#oferta';
interface CTAButtonProps {
  label?: string;
  pulse?: boolean;
  fullWidth?: boolean;
  className?: string;
}
export function CTAButton({
  label = '→ QUIERO MI MEGAPACK AHORA',
  pulse = false,
  fullWidth = false,
  className = ''
}: CTAButtonProps) {
  return <a href={MERCADO_PAGO_URL} className={`group inline-flex items-center justify-center gap-3 rounded-lg bg-orange px-8 py-4 sm:px-10 sm:py-[18px] font-heading font-bold uppercase tracking-wide text-white shadow-cta transition-all duration-200 hover:bg-orange-hover hover:scale-[1.03] hover:shadow-cta-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange ${pulse ? 'animate-pulseGlow' : ''} ${fullWidth ? 'w-[95%] sm:w-full max-w-2xl' : ''} ${className}`} data-id="element-28">
      <span className="text-base sm:text-lg" data-id="element-29">{label}</span>
    </a>;
}